
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import bgImage2 from "../../assets/bgSignup.png";
import API_URL from "../../services/api";
import "./Login.css";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const roleLabel = location.state?.role || "User";

  const [memberId, setMemberId] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // Prevent browser back button
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    const onBack = () => {
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", onBack);

    return () => {
      window.removeEventListener("popstate", onBack);
    };
  }, []);

  const handleLogin = async () => {
    if (!memberId || !password) {
      alert("Please fill all fields");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${API_URL}/api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: memberId,
          password: password,
        }),
      });

      const data = await res.json();

      setLoading(false);

      if (!res.ok) {
        alert(data.message || "Login failed");
        return;
      }

      if (!data.token || !data.user) {
        alert("Invalid server response");
        return;
      }

      // Store clean user information
      const userData = {
        user_id: data.user.user_id,
        name: data.user.name,
        email: data.user.email,
        role: data.user.role,
      };

      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(userData));

      console.log("LOGIN USER STORED:", userData);

      // Role-based routing
      const role = data.user.role;

      if (role === "admin") {
        navigate("/admin");
      } else if (role === "librarian") {
        navigate("/librarian");
      } else {
        navigate("/user");
      }

    } catch (err) {
      setLoading(false);

      console.log("LOGIN ERROR:", err);

      alert("Server error");
    }
  };

  return (
    <div className="login-page">

      <div className="login-card">

        {/* Background Image */}
        <div
          className="login-card-background"
          style={{
            backgroundImage: `url(${bgImage2})`,
          }}
        ></div>

        {/* Login Content */}
        <div className="login-content">

          <h2 className="login-title">
            {roleLabel} Login
          </h2>

          <p className="login-subtitle">
            Access your library account
          </p>

          <input
            className="login-input"
            type="email"
            placeholder="Enter Email address"
            value={memberId}
            onChange={(e) => setMemberId(e.target.value)}
          />

          <input
            className="login-input"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !loading) {
                handleLogin();
              }
            }}
          />

          <button
            className={`login-button ${
              loading ? "login-button-loading" : ""
            }`}
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>

          <p className="login-footer">
            Don’t have an account?{" "}

            <span
              onClick={() => navigate("/signup")}
              className="login-link"
            >
              Signup
            </span>
          </p>

        </div>

      </div>

    </div>
  );
};

export default Login;
